"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIntegrationConnectionsData = exports.selectQuoteAnalysisBundlesData = exports.selectRechargedVendorsData = exports.selectCompaniesForAdminData = exports.selectAllIntegrationConnectionsData = exports.selectAllCompaniesMap = exports.selectServicesMap = void 0;
var omitBy_1 = __importDefault(require("lodash/omitBy"));
var reselect_1 = require("reselect");
var utils_1 = require("./utils");
exports.selectServicesMap = (0, utils_1.makeSelectData)('services');
exports.selectAllCompaniesMap = (0, utils_1.makeSelectData)('allCompanies');
exports.selectAllIntegrationConnectionsData = (0, utils_1.makeSelectData)('integration_connections');
exports.selectCompaniesForAdminData = (0, utils_1.makeSelectData)('companies_for_admin');
exports.selectRechargedVendorsData = (0, utils_1.makeSelectData)('recharged_vendors');
exports.selectQuoteAnalysisBundlesData = (0, utils_1.makeSelectData)('quote_analysis_bundles');
exports.selectIntegrationConnectionsData = (0, reselect_1.createSelector)(exports.selectAllIntegrationConnectionsData, function (allIntConns) { return (0, omitBy_1.default)(allIntConns, 'deletedOn'); });
